import { motion } from "framer-motion";
import { LineChart, Dumbbell, ArrowLeftRight, ArrowUpRight } from "lucide-react";
import { useContent } from "@/lib/content";

const FEATURES = [
  {
    icon: Dumbbell,
    text: "Segna ogni esercizio, carico e ripetizione delle tue sessioni in sala pesi.",
  },
  {
    icon: ArrowLeftRight,
    text: "Confronta due sessioni e scopri quanto sei migliorato, esercizio per esercizio.",
  },
  {
    icon: LineChart,
    text: "Traccia ogni progressione nel tempo e costruisci risultati concreti.",
  },
];

export default function LogbookSection() {
  const c = useContent();
  return (
    <section
      id="logbook"
      data-testid="section-logbook"
      className="relative px-6 md:px-16 py-28 md:py-40 border-t border-[rgba(176,132,51,0.15)] overflow-hidden"
    >
      <div className="max-w-[1200px] mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-80px" }}
          transition={{ duration: 0.8 }}
          className="mb-14"
        >
          <span className="font-editorial italic text-gold/60 text-3xl md:text-5xl leading-none block mb-4">07</span>
          <h2 className="font-display text-4xl md:text-6xl tracking-wide text-bone leading-[0.95]">
            IL NOSTRO LOGBOOK
          </h2>
          <p className="text-bone/60 text-sm md:text-base mt-4 max-w-2xl leading-relaxed">
            {c.logbook_desc}
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mb-14">
          {FEATURES.map((f, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-40px" }}
              transition={{ duration: 0.7, delay: i * 0.12 }}
              className="border border-[rgba(176,132,51,0.2)] bg-surface/60 p-8 flex flex-col gap-4 hover:border-gold/50 transition-colors duration-300"
            >
              <f.icon size={28} className="text-gold" />
              <p className="text-bone/70 text-sm leading-relaxed">{f.text}</p>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
          className="flex flex-col items-start gap-3"
        >
          <a
            data-testid="logbook-cta"
            href={c.logbook_url}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-gold text-ink font-display tracking-[0.2em] text-xl px-10 py-4 hover:bg-gold-dark hover:gap-5 transition-all duration-300"
          >
            ACCEDI AL LOGBOOK <ArrowUpRight size={22} />
          </a>
          <p className="text-bone/40 text-xs">
            Il Logbook può essere utilizzato solo da chi ha un abbonamento Full Stack attivo.
          </p>
        </motion.div>

        <motion.p
          data-testid="logbook-claim"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 1 }}
          className="font-display text-bone leading-[0.95] tracking-wide mt-24 md:mt-32 text-[13vw] md:text-[8.5vw]"
        >
          LE TUE PROGRESSIONI
          <br />
          <span className="text-gold">COMINCIANO DA QUI</span>
        </motion.p>
      </div>
    </section>
  );
}
